import type { RespostasPersonalizadasIzzaModel, CampoRespostaIzza } from "../models/respostasPersonalizadasIzzaModel"

export enum RespostasPersonalizadasIzzaActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_RESPOSTA = "ATUALIZAR_RESPOSTA",
    TOGGLE_ATIVO = "TOGGLE_ATIVO",
}

export type RespostasPersonalizadasIzzaActionModel =
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.CARREGAR
          payload: RespostasPersonalizadasIzzaModel
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.ATUALIZAR_RESPOSTA
          payload: { campo: CampoRespostaIzza; resposta: string }
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.TOGGLE_ATIVO
          payload: { campo: CampoRespostaIzza }
      }
